import React, { useState } from 'react';
import MainScreen from './MainScreen';
import { VocreaLogo } from './VocreaLogo';
import { Menu, X, LogOut, MessageSquare, CreditCard } from 'lucide-react';
import { useApp } from '../context/AppContext';
import '../styles/ResponsiveMainScreen.css';

const ResponsiveMainScreen: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { state, logout } = useApp();

  const handleLogout = () => {
    logout();
    // SPA navigation - triggers App.tsx routing
    window.history.pushState({}, "", "/");
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  const userName = state.user?.name || 'User';
  const userInitials = userName
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className="responsive-main-screen">
      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Mobile Sidebar */}
      <aside className={`mobile-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="mobile-sidebar-content">
          {/* Close button */}
          <button
            onClick={() => setIsSidebarOpen(false)}
            className="mobile-sidebar-close"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>

          {/* Logo */}
          <div className="mobile-sidebar-header">
            <div className="flex items-center gap-2">
              <VocreaLogo />
              <span className="text-xl text-gray-700">Vocrea AI</span>
            </div>
          </div>

          {/* User Profile */}
          <div className="mobile-sidebar-profile">
            <div className="flex flex-col items-center text-center space-y-3">
              <div className="mobile-avatar">
                {state.user?.profile_photo_url ? (
                  <img src={state.user.profile_photo_url} alt={userName} />
                ) : (
                  <div className="mobile-avatar-fallback">
                    {userInitials}
                  </div>
                )}
              </div>
              <div>
                <h2 className="text-gray-700">{userName}</h2>
                <p className="text-sm text-gray-600">VocreaAI Member</p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="mobile-sidebar-nav">
            <button
              className="mobile-nav-button active"
              onClick={() => setIsSidebarOpen(false)}
            >
              <MessageSquare className="w-5 h-5" />
              <span>Chat</span>
            </button>
            <button
              className="mobile-nav-button"
              onClick={() => {
                // SPA navigation - triggers App.tsx routing
                console.log("[ResponsiveMainScreen] Navigating to payment history");
                window.history.pushState({}, "", "/payment/history");
                window.dispatchEvent(new PopStateEvent("popstate"));
                setIsSidebarOpen(false);  // Close sidebar after navigation
              }}
            >
              <CreditCard className="w-5 h-5" />
              <span>Payment History</span>
            </button>
          </nav>

          {/* Logout */}
          <div className="mobile-sidebar-footer">
            <button
              onClick={handleLogout}
              className="mobile-logout-button"
            >
              <LogOut className="w-5 h-5" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </aside>

      {/* Mobile Header */}
      <header className="mobile-header">
        <button
          onClick={() => setIsSidebarOpen(true)}
          className="mobile-menu-button"
        >
          <Menu className="w-6 h-6 text-gray-700" />
        </button>
        <div className="flex items-center gap-2">
          <VocreaLogo />
          <span className="text-gray-700">Vocrea AI</span>
        </div>
      </header>

      {/* Main Content - wraps MainScreen */}
      <div className="main-content-wrapper">
        <MainScreen />
      </div>
    </div>
  );
};

export default ResponsiveMainScreen;
